import { createFileRoute } from "@tanstack/react-router"

import { LoginVerify } from "#pages/login/login-verify.tsx"

export const Route = createFileRoute("/_auth/login-verify")({
  component: LoginVerify,
})
